export default __webpack_public_path__ + "static/media/modal.952f6ec8.png";